'use client'

import { Spinorama, SpinoramaWrapper, SpinoramaItem, SpinoramaNext, SpinoramaPrev } from 'spinorama'

// Types
import type { SliderProps } from '@/types/components/molecules/sliders/basic'

const BasicSliderMolecule = (props: SliderProps) => {
	// Props
	const { items } = props

	return (
		<Spinorama width={1} px={5}>
			<SpinoramaWrapper alignItems="stretch" spacing={2}>
				{items.map((item, index) => (
					<SpinoramaItem
						key={index}
						size={{ xs: 12, md: 4 }}
						sx={{
							'& picture': {
								width: 1,
								height: 1,
								'& img': {
									width: 1,
									height: 1,
									objectFit: 'scale-down',
									objectPosition: 'center'
								}
							}
						}}
					>
						<picture>
							<img src={`/api/download${item.image}`} alt={item.alt} />
						</picture>
					</SpinoramaItem>
				))}
			</SpinoramaWrapper>

			<SpinoramaPrev layout="center-left" />
			<SpinoramaNext layout="center-right" />
		</Spinorama>
	)
}

export default BasicSliderMolecule
